
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Hotel, RoomFormData } from "@/types/hotel";

interface RoomDialogBasicInfoProps {
  formData: RoomFormData;
  setFormData: React.Dispatch<React.SetStateAction<RoomFormData>>;
  hotels: Hotel[];
  preselectedHotelId?: string;
  selectedHotel: Hotel | undefined;
}

export const RoomDialogBasicInfo = ({ formData, setFormData, hotels, preselectedHotelId, selectedHotel }: RoomDialogBasicInfoProps) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="hotel_id">الفندق</Label>
        <Select
          value={formData.hotel_id}
          onValueChange={(value) => setFormData(prev => ({ ...prev, hotel_id: value }))}
          required
          disabled={!!preselectedHotelId}
        >
          <SelectTrigger>
            <SelectValue placeholder="اختر الفندق" />
          </SelectTrigger>
          <SelectContent>
            {hotels.map((hotel) => (
              <SelectItem key={hotel.id} value={hotel.id}>
                {hotel.name_ar} - {hotel.city}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        {selectedHotel && (
          <p className="text-sm text-gray-600">
            {selectedHotel.name_en} - {selectedHotel.city}, {selectedHotel.country}
          </p>
        )}
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="name">اسم الغرفة بالعربية</Label>
          <Input
            id="name"
            value={formData.name}
            onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
            placeholder="مثال: غرفة مفردة - إطلالة على البحر"
            required
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="name_en">اسم الغرفة بالإنجليزية</Label>
          <Input
            id="name_en"
            value={formData.name_en}
            onChange={(e) => setFormData(prev => ({ ...prev, name_en: e.target.value }))}
            placeholder="Example: Single Room - Sea View"
          />
        </div>
      </div>
    </>
  );
}
